module.exports = {"add":"Add","areYouSure":"Are you sure ?","back":"Back","cancel":"Cancel","close":"Close","code":"Code","create":"Create","delete":"Delete","deleteMessage":"Confirm to delete this item ?","deleteSuccess":"Delete success","description":"Description","edit":"Edit","login":"Login","logout":"Logout","name":"Name","noData":"No Data","ok":"OK","remember":"Remember","select":"Select","share":"Share","submit":"Submit","success":"Success","systemMessage":"System Message","password":"Password","view":"View","update":"Update","userName":"Username","userRole":"Role","welcome":"Welcome "}


//////////////////
// WEBPACK FOOTER
// ./src/language/en/common.json
// module id = 1009
// module chunks = 10